/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description pointBytimeUsingGet参数
 * @property `endTime` 结束时间
 * @property `startTime` 开始时间
 */
export interface ParamspointBytimeUsingGet {
  // queryParams
  /**
   * 结束时间
   */
  endTime: string;
  /**
   * 开始时间
   */
  startTime: string;
}
/**
 * @description pointInitUsingGet参数
 * @property `endTime` 结束时间
 * @property `[startTime]` 开始时间
 */
export interface ParamspointInitUsingGet {
  // queryParams
  /**
   * 结束时间
   */
  endTime: string;
  /**
   * 开始时间
   */
  startTime?: string;
}
/**
 * @description pointUsernameUsingGet参数
 * @property `username` 用户名
 */
export interface ParamspointUsernameUsingGet {
  // pathParams
  /**
   * 用户名
   */
  username: string;
}
export class PointApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 查看时间段内所有人的积分
   * @param params ParamspointBytimeUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListPointInfo
   */
  public pointBytimeUsingGet = (
    params: ParamspointBytimeUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListPointInfo> => {
    const path = '/api/point/bytime';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('endTime' in params) p.query.endTime = params.endTime;
    ajax.check(params.endTime, 'endTime');
    if ('startTime' in params) p.query.startTime = params.startTime;
    ajax.check(params.startTime, 'startTime');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 计算用户在某一节点前的初始积分 并入库
   * @param params ParamspointInitUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public pointInitUsingGet = (
    params: ParamspointInitUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/point/init';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('endTime' in params) p.query.endTime = params.endTime;
    ajax.check(params.endTime, 'endTime');
    if ('startTime' in params) p.query.startTime = params.startTime;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看积分
   * @param params ParamspointUsernameUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPointInfo
   */
  public pointUsernameUsingGet = (
    params: ParamspointUsernameUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPointInfo> => {
    const path = '/api/point/{username}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.username, 'username');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new PointApi();
